import styled from "styled-components";

export const RadioContainer = styled.label`
  width: fit-content;
  display: flex;
  align-items: center;
  border: 2px solid #BDBDBD;
  border-radius: 0.5rem;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  &:hover {
    cursor: pointer;
  }
`;

export const RadioInput = styled.input<{color: string}>`
  position: relative;
  appearance: none;
  width: auto;
  &::after, &::before {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
  }
  
  &::after {
    left: 5px;
    width: 0.6rem;
    height: 0.6rem;
    visibility: hidden;
    background-color: ${({color}) => color};
  }

  &::before {
    left: 0;
    width: 1rem;
    height: 1rem;
    border: 2px solid #BDBDBD;
  }
  
  &:checked {
    &::after {
      visibility: visible;
    }
    
    &::before {
      border: 2px solid ${({color}) => color};
    }
  }
`;

export const RadioLabel = styled.span`
  margin-left: 1.25rem;
  font-size: 1rem;
`;
